'use strict';

// Picture Polyfill
// Source : https://github.com/verlok/picturePolyfill/
//
// The source file was MODIFIED to have better compatibility
// with webpack.
//
// Those two lines at the end of the file :
//      picturePolyfill.initialize();
//      picturePolyfill.parse();
//
// were replace by a module export :
//      module.exports = picturePolyfill;
//
// This give use better compatibility with the module system, 
// and better control when to trigger call (initialization, parse).

var picturePolyfill = require("./picturePolyfill.js");
picturePolyfill.initialize();
picturePolyfill.parse();


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/picture-polyfill/index.js
// module id = 260
// module chunks = 0